import { createClients as createClientsBase } from '@tiny-type-api/client';
import { ecApis } from './ecUniversal.js';
export const createClients = (host) => createClientsBase(ecApis, host);
//# sourceMappingURL=ecClient.js.map